import React, { Component } from "react";
import { motion } from "framer-motion";
import MenuBar from "../../layouts/MenuBar";
import Footer from "../../layouts/Footer";
import Hero from "../../layouts/Hero";
import { connect } from "react-redux";
import bizd from "../../assets/img/Turbnew.jpg";
import biz from "../../assets/img/Turbnew.jpg";
import { toast, ToastContainer } from "react-toastify";
import { Turboaction } from "../../state-management/actions/auth/TurboActions";
import PropTypes from "prop-types";
import { getCountries } from "../../state-management/actions/location/location-action";
import plans from "../../data/plans";

const inputClass =
  "w-full rounded-xl border border-gray-200 bg-gray-50/60 px-3.5 py-3 text-[15px] text-brand-dark transition-colors focus:outline-none focus:ring-2 focus:ring-brand-teal focus:border-brand-teal focus:bg-white";
const labelClass = "mb-1.5 block text-sm font-medium text-brand-dark/80";

class Turbos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first: "",
      last: "",
      address: "",
      email: "",
      alternateEmail: "",
      phone: "",
      country: "",
      state: "",
      alternatePhone: "",
      referral: "",
      passsword: "",
      plan: this.props.location.state
        ? this.props.location.state.plan
        : plans[0].plan,
      planName: this.props.location.state
        ? this.props.location.state.planName
        : plans[0].slug,
      amount: this.props.location.state
        ? this.props.location.state.amount
        : plans[0].price,
      about: "",
      source: "",
      phoneError: "",
      terms: false,
      payment_option: "paystack",
    };
  }

  static propTypes = {
    load: PropTypes.bool.isRequired,
  };

  Turboaction = (e) => {
    e.preventDefault();
    const {
      first,
      last,
      address,
      email,
      phone,
      source,
      payment_option,
      amount,
      country,
      state,
      planName,
    } = this.state;
    const data = {
      firstName: first,
      lastName: last,
      address,
      email,
      phoneNumber: phone,
      language: "english",
      country,
      state,
      allowEmail: true,
      plan: planName,
      about_us: source,
      payment_option,
    };
    const numbers = /^[0-9]+$/;
    if (!phone.match(numbers)) {
      toast.info("Please enter only numbers");
    } else if (phone.length !== 11) {
      toast.info("invalid phone number");
    } else {
      this.props.Turboaction(data, amount, this.props.history);
    }
  };

  onChange = (e) =>
    this.setState({
      [e.target.name]: e.target.value,
    });

  handleInputChange = (event) => {
    const { name, type, checked, value } = event.target;
    this.setState({
      [name]: type === "checkbox" ? checked : value,
    });
  };

  handleNumber = (e) => {
    const { name, value } = e.target;
    if (isNaN(Number(value))) return;
    this.setState({ [name]: value });
  };

  handleSpaceBar = (e) => {
    if (e.keyCode === 32) e.preventDefault();
  };

  selectPlan = (planItem) => {
    this.setState({
      plan: planItem.plan,
      planName: planItem.slug,
      amount: planItem.price,
    });
  };

  submitForm() {
    const { first, last, address, email, phone, terms, country, state } =
      this.state;
    return (
      first.length > 0 &&
      last.length > 0 &&
      address.length > 0 &&
      email.length > 0 &&
      state.length > 0 &&
      country.length > 0 &&
      phone.length === 11 &&
      terms
    );
  }

  componentDidMount() {
    this.props.getCountries();
    this.scrollTimer = setTimeout(() => {
      document
        .getElementById("signup-form")
        ?.scrollIntoView({ behavior: "smooth" });
    }, 3000);
  }

  componentWillUnmount() {
    clearTimeout(this.scrollTimer);
  }

  displayStateAndRegions = () => {
    if (this.state.country === "gh") {
      return this.props.countries
        .filter((country) => country.country === "Ghana")
        .map((state) => <option value={state.state}>{state.state}</option>);
    } else if (this.state.country === "cv") {
      return this.props.countries
        .filter((country) => country.country === "Cote d'Ivoire")
        .map((state) => <option value={state.state}>{state.state}</option>);
    } else {
      return this.props.countries
        .filter((country) => country.country === "Nigeria")
        .map((state) => <option value={state.state}>{state.state}</option>);
    }
  };

  render() {
    const { load } = this.props;
    const isEnabled = this.submitForm();

    const { first, last, address, email, phone, terms, plan, planName } =
      this.state;
    return (
      <div>
        <MenuBar />
        <Hero
          title={plan}
          description={
            <>
              The Next Generation of our Unlimited Internet, {plan} will
              provide data and voice services to Enterprise Business
              District, Estate, Multi-Story Building, and Housing Complex.
              Tizeti proposes providing a wireless network solution for your
              organization in the following capacity; Digital landline
              Telephone, Surveillance, Internet Service etc.
            </>
          }
          image={planName === "turbo_connect" ? bizd : biz}
          imageAlt={plan}
        />
        <motion.div
          id="signup-form"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="max-w-3xl mx-auto px-4 -mt-6 md:-mt-12 relative z-10 mb-16 scroll-mt-[112px] sm:scroll-mt-[128px] md:scroll-mt-[152px]"
        >
          <form
            className="rounded-2xl bg-white p-6 md:p-8 shadow-[0px_15px_35px_0px_rgba(0,0,0,0.08)] border border-black/5"
            onSubmit={this.Turboaction}
          >
            <div className="mb-6 pb-6 border-b border-black/5">
              <h2 className="text-xl font-bold text-brand-dark">
                Complete Your Sign Up
              </h2>
              <p className="mt-1 text-sm text-gray-500">
                Fill in your details to activate your plan.
              </p>
              <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-2">
                {plans.map((item) => {
                  const selected = item.slug === planName;
                  return (
                    <button
                      key={item.slug}
                      type="button"
                      onClick={() => this.selectPlan(item)}
                      aria-pressed={selected}
                      className={`relative rounded-xl border px-3.5 py-2.5 text-left transition-colors ${
                        selected
                          ? "border-brand-teal bg-brand-teal shadow-md shadow-brand-teal/25"
                          : "border-gray-200 bg-white hover:border-brand-teal/40"
                      }`}
                    >
                      {selected && (
                        <i className="fa fa-check-circle absolute top-2 right-2.5 text-white text-sm" />
                      )}
                      <span
                        className={`block text-sm font-semibold ${
                          selected ? "text-white" : "text-brand-dark"
                        }`}
                      >
                        {item.title}
                      </span>
                      <span
                        className={`block text-sm font-bold ${
                          selected ? "text-white" : "text-brand-teal"
                        }`}
                      >
                        &#8358;{item.amount}/month
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="text-left space-y-5">
              <div className="flex gap-3">
                <div className="flex-1">
                  <label className={labelClass}>First Name</label>
                  <input
                    type="text"
                    name="first"
                    value={first}
                    onChange={this.onChange}
                    className={inputClass}
                    placeholder="First Name"
                  />
                </div>

                <div className="flex-1">
                  <label className={labelClass}>Last Name</label>
                  <input
                    type="text"
                    className={inputClass}
                    name="last"
                    value={last}
                    onChange={this.onChange}
                    placeholder="Last Name"
                  />
                </div>
              </div>

              <div className="flex gap-3">
                <div className="flex-1">
                  <label className={labelClass}>Phone Number</label>
                  <input
                    type="tel"
                    pattern="0[789]{1}[01]{1}[0-9]{8}"
                    title="Please enter your valid 11-digit phone number"
                    className={inputClass}
                    name="phone"
                    value={phone}
                    maxLength="11"
                    placeholder="Phone number"
                    onChange={this.handleNumber}
                    onKeyDown={this.handleSpaceBar}
                  />
                </div>

                <div className="flex-1">
                  <label className={labelClass}>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={this.onChange}
                    className={inputClass}
                    placeholder="Contact email address"
                  />
                </div>
              </div>

              <div>
                <label className={labelClass}>How Did You Hear About Us?</label>
                <select
                  className={inputClass}
                  name="source"
                  onChange={this.onChange}
                >
                  <option value="">Select</option>

                  <option value="google ads">Google Ads</option>
                  <option value="facebook">Facebook</option>
                  <option value="linkedin">LinkedIn</option>
                  <option value="flyer">Flyer</option>
                  <option value="billboard">Billboard</option>
                  <option value="mobile advert">Mobile Advert</option>
                  <option value="friend">Friend</option>
                  <option value="instagram">Instagram</option>
                  <option value="television">Television</option>
                  <option value="radio">Radio</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="flex gap-3">
                <div className="flex-1">
                  <label className={labelClass}>Country</label>
                  <select
                    className={inputClass}
                    name="country"
                    onChange={this.onChange}
                    required
                  >
                    <option required>Select Country</option>
                    {this.props.countries
                      .filter(
                        (item, index, i) =>
                          i.findIndex((t) => t.country === item.country) === index
                      )
                      .map((country) => (
                        <option value={country.country === "Ghana" ? "gh" : "ng"}>
                          {country.country}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="flex-1">
                  <label className={labelClass}>State</label>
                  <select
                    className={inputClass}
                    name="state"
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    required
                  >
                    <option>Select State</option>
                    {this.displayStateAndRegions()}
                  </select>
                </div>
              </div>

              <div>
                <label className={labelClass}>Physical Address</label>
                <textarea
                  className={inputClass}
                  name="address"
                  value={address}
                  onChange={this.onChange}
                  placeholder="Physical address"
                  rows="5"
                />
              </div>

              <div className="flex items-start gap-2.5 pt-1">
                <input
                  type="checkbox"
                  id="terms"
                  name="terms"
                  checked={terms}
                  onChange={this.handleInputChange}
                  className="mt-0.5 h-4 w-4 shrink-0 rounded border-gray-300 accent-brand-teal focus:ring-brand-teal"
                />
                <label htmlFor="terms" className="text-sm text-gray-600 leading-relaxed">
                  By signing up, you agree to our{" "}
                  <a
                    href="http://wifi.com.ng/terms"
                    className="text-brand-teal font-medium no-underline hover:underline"
                  >
                    Terms and Conditions
                  </a>
                </label>
              </div>
              <div>
                {load ? (
                  <input
                    disabled={true}
                    className="w-full h-14 rounded-xl bg-brand-teal text-white font-semibold text-base cursor-pointer"
                    value="Submitting..."
                    type="submit"
                  />
                ) : (
                  <motion.input
                    whileHover={isEnabled ? { scale: 1.02 } : {}}
                    whileTap={isEnabled ? { scale: 0.98 } : {}}
                    disabled={!isEnabled}
                    className="w-full h-14 rounded-xl bg-brand-teal text-white font-semibold text-base cursor-pointer hover:bg-brand-teal-dark transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    value="Proceed"
                    type="submit"
                  />
                )}
              </div>
            </div>
          </form>
        </motion.div>
        <ToastContainer />
        <Footer />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  load: state.signUp.load,
  countries: state.location.countries,
});

export default connect(mapStateToProps, { Turboaction, getCountries })(Turbos);
